/**
 * Copyright 2020 ExpediaGroup. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const SupportedLocalesMap = Object.freeze({
  ar_ae: {
    default: 'en',
    supported: ['ar'],
  },
  ca_es: {
    default: 'en',
    supported: ['ca'],
  },
  cs_cz: {
    default: 'en',
    supported: ['cs'],
  },
  da_dk: {
    default: 'en',
    supported: ['da'],
  },
  de_at: {
    default: 'en',
    supported: ['de'],
  },
  de_be: {
    default: 'en',
    supported: ['de'],
  },
  de_ch: {
    default: 'en',
    supported: ['de'],
  },
  de_de: {
    default: 'en',
    supported: ['de'],
  },
  el_gr: {
    default: 'en',
    supported: ['el'],
  },
  en_as: {
    default: 'en',
    supported: ['en'],
  },
  en_au: {
    default: 'en',
    supported: ['en'],
  },
  en_ca: {
    default: 'en',
    supported: ['en'],
  },
  en_cn: {
    default: 'en',
    supported: ['en'],
  },
  en_es: {
    default: 'en',
    supported: ['en'],
  },
  en_gb: {
    default: 'en',
    supported: ['en'],
  },
  en_hk: {
    default: 'en',
    supported: ['en'],
  },
  en_id: {
    default: 'en',
    supported: ['en'],
  },
  en_ie: {
    default: 'en',
    supported: ['en'],
  },
  en_il: {
    default: 'en',
    supported: ['en'],
  },
  en_in: {
    default: 'en',
    supported: ['en'],
  },
  en_jp: {
    default: 'en',
    supported: ['en'],
  },
  en_kr: {
    default: 'en',
    supported: ['en'],
  },
  en_la: {
    default: 'en',
    supported: ['en'],
  },
  en_mx: {
    default: 'en',
    supported: ['en'],
  },
  en_my: {
    default: 'en',
    supported: ['en'],
  },
  en_nz: {
    default: 'en',
    supported: ['en'],
  },
  en_ph: {
    default: 'en',
    supported: ['en'],
  },
  en_sg: {
    default: 'en',
    supported: ['en'],
  },
  en_th: {
    default: 'en',
    supported: ['en'],
  },
  en_tw: {
    default: 'en',
    supported: ['en'],
  },
  en_us: {
    default: 'en',
    supported: ['en'],
  },
  en_vn: {
    default: 'en',
    supported: ['en'],
  },
  en_za: {
    default: 'en',
    supported: ['en'],
  },
  es_ar: {
    default: 'en',
    supported: ['es'],
  },
  es_bo: {
    default: 'en',
    supported: ['es'],
  },
  es_bz: {
    default: 'en',
    supported: ['es'],
  },
  es_cl: {
    default: 'en',
    supported: ['es'],
  },
  es_co: {
    default: 'en',
    supported: ['es'],
  },
  es_cr: {
    default: 'en',
    supported: ['es'],
  },
  es_ec: {
    default: 'en',
    supported: ['es'],
  },
  es_es: {
    default: 'en',
    supported: ['es'],
  },
  es_gt: {
    default: 'en',
    supported: ['es'],
  },
  es_gy: {
    default: 'en',
    supported: ['es'],
  },
  es_hn: {
    default: 'en',
    supported: ['es'],
  },
  es_mx: {
    default: 'en',
    supported: ['es'],
  },
  es_ni: {
    default: 'en',
    supported: ['es'],
  },
  es_pa: {
    default: 'en',
    supported: ['es'],
  },
  es_pe: {
    default: 'en',
    supported: ['es'],
  },
  es_py: {
    default: 'en',
    supported: ['es'],
  },
  es_sv: {
    default: 'en',
    supported: ['es'],
  },
  es_uy: {
    default: 'en',
    supported: ['es'],
  },
  es_ve: {
    default: 'en',
    supported: ['es'],
  },
  et_ee: {
    default: 'en',
    supported: ['et'],
  },
  fi_fi: {
    default: 'en',
    supported: ['fi'],
  },
  fr_be: {
    default: 'en',
    supported: ['fr'],
  },
  fr_ca: {
    default: 'en',
    supported: ['fr'],
  },
  fr_ch: {
    default: 'en',
    supported: ['fr'],
  },
  fr_fr: {
    default: 'en',
    supported: ['fr'],
  },
  fr_gf: {
    default: 'en',
    supported: ['fr'],
  },
  hr_hr: {
    default: 'en',
    supported: ['hr'],
  },
  hu_hu: {
    default: 'en',
    supported: ['hu'],
  },
  id_id: {
    default: 'en',
    supported: ['id'],
  },
  in_id: {
    default: 'en',
    supported: ['in'],
  },
  is_is: {
    default: 'en',
    supported: ['is'],
  },
  it_ch: {
    default: 'en',
    supported: ['it'],
  },
  it_it: {
    default: 'en',
    supported: ['it'],
  },
  lt_lt: {
    default: 'en',
    supported: ['lt'],
  },
  lv_iv: {
    default: 'en',
    supported: ['lv'],
  },
  iw_il: {
    default: 'en',
    supported: ['iw'],
  },
  ja_jp: {
    default: 'en',
    supported: ['ja'],
  },
  ko_kr: {
    default: 'en',
    supported: ['ko'],
  },
  ms_my: {
    default: 'en',
    supported: ['ms'],
  },
  nb_no: {
    default: 'en',
    supported: ['nb'],
  },
  no_no: {
    default: 'en',
    supported: ['no'],
  },
  nl_be: {
    default: 'en',
    supported: ['nl'],
  },
  nl_nl: {
    default: 'en',
    supported: ['nl'],
  },
  nl_sr: {
    default: 'en',
    supported: ['nl'],
  },
  pl_pl: {
    default: 'en',
    supported: ['pl'],
  },
  pt_br: {
    default: 'en',
    supported: ['pt'],
  },
  pt_pt: {
    default: 'en',
    supported: ['pt'],
  },
  ru_ru: {
    default: 'en',
    supported: ['ru'],
  },
  sk_sk: {
    default: 'en',
    supported: ['sk'],
  },
  sv_se: {
    default: 'en',
    supported: ['sv'],
  },
  th_th: {
    default: 'en',
    supported: ['th'],
  },
  tr_tr: {
    default: 'en',
    supported: ['tr'],
  },
  uk_ua: {
    default: 'en',
    supported: ['uk'],
  },
  vi_vn: {
    default: 'en',
    supported: ['vi'],
  },
  zh_cn: {
    default: 'en',
    supported: ['zh'],
  },
  zh_hk: {
    default: 'en',
    supported: ['zh'],
  },
  zh_tw: {
    default: 'en',
    supported: ['zh'],
  },
});

export default SupportedLocalesMap;
